import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { SUPPORTED_LANGS, OG_LOCALES } from "../i18n";
import { images } from "../content/siteConfig";

const PAGE_PATHS = {
  home: "",
  tech: "/odf-technology",
  solutions: "/solutions",
  partnership: "/partnerships",
  about: "/about",
  contact: "/contact",
  privacy: "/privacy",
  terms: "/terms",
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SEO = ({ page }) => {
  const { t, lang } = useLang();
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = t.seo[page];
    if (!meta) return;
    const origin = window.location.origin;
    const pagePath = PAGE_PATHS[page] ?? "";

    document.title = meta.title;
    setMeta("name", "description", meta.desc);
    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", meta.desc);
    setMeta("property", "og:image", images.ogSocial);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", `${origin}/${lang}${pagePath}`);
    setMeta("property", "og:locale", OG_LOCALES[lang]);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${origin}/${lang}${pagePath}`);

    document.head.querySelectorAll("link[data-nortis-hreflang]").forEach((el) => el.remove());
    const addAlt = (hreflang, href) => {
      const link = document.createElement("link");
      link.setAttribute("rel", "alternate");
      link.setAttribute("hreflang", hreflang);
      link.setAttribute("href", href);
      link.setAttribute("data-nortis-hreflang", "true");
      document.head.appendChild(link);
    };
    SUPPORTED_LANGS.forEach((l) => addAlt(l, `${origin}/${l}${pagePath}`));
    addAlt("x-default", `${origin}/en${pagePath}`);
  }, [page, t, lang, pathname]);

  return null;
};
